/**
 * Code samples of the graphical requests API documentation. Code is the same
 * in every language; {{BASE}} is replaced by the API base URL of this server.
 * One entry per sample, one string per client language (shown as tabs).
 */
define('apiDocsSamples',[], function () {
  'use strict';

  var lines = function () {
    return Array.prototype.slice.call(arguments).join('\n');
  };

  return {
    clients: [
      {id: 'curl', label: 'cURL'},
      {id: 'node', label: 'Node.js'},
      {id: 'php', label: 'PHP'},
      {id: 'python', label: 'Python'}
    ],

    auth: {
      curl: lines(
        'curl {{BASE}}/credits \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      ),
      node: lines(
        'const res = await fetch(\'{{BASE}}/credits\', {',
        '  headers: { Authorization: `Bearer ${process.env.COMPUZZ_API_KEY}` }',
        '});',
        'console.log(await res.json());'
      ),
      php: lines(
        '$ch = curl_init(\'{{BASE}}/credits\');',
        'curl_setopt_array($ch, [',
        '    CURLOPT_HTTPHEADER => [\'Authorization: Bearer \' . getenv(\'COMPUZZ_API_KEY\')],',
        '    CURLOPT_RETURNTRANSFER => true,',
        ']);',
        '$credits = json_decode(curl_exec($ch), true);'
      ),
      python: lines(
        'import os, requests',
        '',
        'API = "{{BASE}}"',
        'HEADERS = {"Authorization": "Bearer " + os.environ["COMPUZZ_API_KEY"]}',
        '',
        'print(requests.get(API + "/credits", headers=HEADERS).json())'
      )
    },

    create: {
      curl: lines(
        'curl {{BASE}}/graphical-requests \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY" \\',
        '  -H "Idempotency-Key: order-10452-logo" \\',
        '  -F type=vectorization \\',
        '  -F name="Logo ACME - order 10452" \\',
        '  -F outputFormat=ai_cc \\',
        '  -F colors="2 colours: Pantone 485 C and black" \\',
        '  -F comment="Keep the font, remove the white background" \\',
        '  -F externalRef=10452 \\',
        '  -F file=@logo-acme.jpg'
      ),
      node: lines(
        'import { readFile } from \'node:fs/promises\';',
        '',
        'const form = new FormData();',
        'form.append(\'type\', \'vectorization\');',
        'form.append(\'name\', \'Logo ACME - order 10452\');',
        'form.append(\'outputFormat\', \'ai_cc\');',
        'form.append(\'colors\', \'2 colours: Pantone 485 C and black\');',
        'form.append(\'externalRef\', \'10452\');',
        'form.append(\'file\', new Blob([await readFile(\'logo-acme.jpg\')]), \'logo-acme.jpg\');',
        '',
        'const res = await fetch(\'{{BASE}}/graphical-requests\', {',
        '  method: \'POST\',',
        '  headers: {',
        '    Authorization: `Bearer ${process.env.COMPUZZ_API_KEY}`,',
        '    \'Idempotency-Key\': \'order-10452-logo\'',
        '  },',
        '  body: form',
        '});',
        'const request = await res.json();   // 201 Created',
        'console.log(request.id, request.status, request.quote.totalCredits);'
      ),
      php: lines(
        '$ch = curl_init(\'{{BASE}}/graphical-requests\');',
        'curl_setopt_array($ch, [',
        '    CURLOPT_POST => true,',
        '    CURLOPT_HTTPHEADER => [',
        '        \'Authorization: Bearer \' . getenv(\'COMPUZZ_API_KEY\'),',
        '        \'Idempotency-Key: order-10452-logo\',',
        '    ],',
        '    CURLOPT_POSTFIELDS => [',
        '        \'type\'         => \'vectorization\',',
        '        \'name\'         => \'Logo ACME - order 10452\',',
        '        \'outputFormat\' => \'ai_cc\',',
        '        \'colors\'       => \'2 colours: Pantone 485 C and black\',',
        '        \'externalRef\'  => \'10452\',',
        '        \'file\'         => new CURLFile(\'logo-acme.jpg\'),',
        '    ],',
        '    CURLOPT_RETURNTRANSFER => true,',
        ']);',
        '$request = json_decode(curl_exec($ch), true);',
        'echo $request[\'id\'], \' \', $request[\'status\'];'
      ),
      python: lines(
        'import os, requests',
        '',
        'API = "{{BASE}}"',
        'HEADERS = {"Authorization": "Bearer " + os.environ["COMPUZZ_API_KEY"]}',
        '',
        'with open("logo-acme.jpg", "rb") as f:',
        '    res = requests.post(',
        '        API + "/graphical-requests",',
        '        headers={**HEADERS, "Idempotency-Key": "order-10452-logo"},',
        '        data={',
        '            "type": "vectorization",',
        '            "name": "Logo ACME - order 10452",',
        '            "outputFormat": "ai_cc",',
        '            "colors": "2 colours: Pantone 485 C and black",',
        '            "externalRef": "10452",',
        '        },',
        '        files={"file": ("logo-acme.jpg", f)},',
        '    )',
        'res.raise_for_status()',
        'request = res.json()',
        'print(request["id"], request["status"])'
      )
    },

    createJson: {
      curl: lines(
        'curl {{BASE}}/graphical-requests \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY" \\',
        '  -H "Content-Type: application/json" \\',
        '  -d \'{',
        '    "type": "remove_background",',
        '    "name": "Product photo 7781",',
        '    "outputFormat": "png",',
        '    "urgent": true,',
        '    "files": [{ "name": "photo-7781.jpg", "content": "/9j/4AAQSkZJRgABAQ..." }]',
        '  }\''
      )
    },

    response: {
      json: lines(
        '{',
        '  "id": "48211_6f1c2e0a-5b7d-4c1e-9a3f-2d8e1b7c9a10",',
        '  "object": "graphical_request",',
        '  "type": "vectorization",',
        '  "name": "Logo ACME - order 10452",',
        '  "status": "delivered",',
        '  "urgent": false,',
        '  "outputFormat": "ai_cc",',
        '  "outputFormatLabel": ".ai (Adobe Illustrator CC)",',
        '  "externalRef": "10452",',
        '  "requester": "integration@your-company.com",',
        '  "source": "api",',
        '  "createdAt": "2026-10-22T08:14:03Z",',
        '  "updatedAt": "2026-10-22T13:40:51Z",',
        '  "deliveredAt": "2026-10-22T13:40:51Z",',
        '  "quote": { "tariffScale": 1, "unitCredits": 6, "urgentCredits": 0, "totalCredits": 6 },',
        '  "files": [',
        '    {',
        '      "id": "a81f0c3e-1d2b-4b8e-8e57-3c1a9f0d6b21",',
        '      "name": "logo-acme.jpg",',
        '      "role": "source",',
        '      "createdAt": "2026-10-22T08:14:03Z",',
        '      "downloadUrl": "{{BASE}}/graphical-requests/48211_6f1c.../files/a81f0c3e-..."',
        '    },',
        '    {',
        '      "id": "c02b7d94-77e1-4f0a-b1e3-5d6a2c8f4e90",',
        '      "name": "Logo ACME order 10452.ai",',
        '      "role": "result",',
        '      "latest": true,',
        '      "createdAt": "2026-10-22T13:40:51Z",',
        '      "downloadUrl": "{{BASE}}/graphical-requests/48211_6f1c.../files/c02b7d94-..."',
        '    }',
        '  ]',
        '}'
      )
    },

    get: {
      curl: lines(
        'curl {{BASE}}/graphical-requests/48211_6f1c2e0a-5b7d-4c1e-9a3f-2d8e1b7c9a10 \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      ),
      node: lines(
        'const res = await fetch(`{{BASE}}/graphical-requests/${id}`, {',
        '  headers: { Authorization: `Bearer ${process.env.COMPUZZ_API_KEY}` }',
        '});',
        'const request = await res.json();'
      ),
      php: lines(
        '$ch = curl_init(\'{{BASE}}/graphical-requests/\' . $id);',
        'curl_setopt_array($ch, [',
        '    CURLOPT_HTTPHEADER => [\'Authorization: Bearer \' . getenv(\'COMPUZZ_API_KEY\')],',
        '    CURLOPT_RETURNTRANSFER => true,',
        ']);',
        '$request = json_decode(curl_exec($ch), true);'
      ),
      python: 'request = requests.get(f"{API}/graphical-requests/{request_id}", headers=HEADERS).json()'
    },

    list: {
      curl: lines(
        'curl "{{BASE}}/graphical-requests?status=delivered&updatedSince=2026-10-21T00:00:00Z&limit=50" \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      ),
      node: lines(
        'let cursor = null;',
        'do {',
        '  const params = new URLSearchParams({ status: \'delivered\', limit: \'100\' });',
        '  if (cursor) params.set(\'startingAfter\', cursor);',
        '  const page = await (await fetch(`{{BASE}}/graphical-requests?${params}`, {',
        '    headers: { Authorization: `Bearer ${process.env.COMPUZZ_API_KEY}` }',
        '  })).json();',
        '  page.data.forEach(r => console.log(r.id, r.externalRef, r.status));',
        '  cursor = page.hasMore ? page.nextCursor : null;',
        '} while (cursor);'
      ),
      php: lines(
        '$cursor = null;',
        'do {',
        '    $query = http_build_query(array_filter([\'status\' => \'delivered\', \'limit\' => 100, \'startingAfter\' => $cursor]));',
        '    $ch = curl_init(\'{{BASE}}/graphical-requests?\' . $query);',
        '    curl_setopt_array($ch, [',
        '        CURLOPT_HTTPHEADER => [\'Authorization: Bearer \' . getenv(\'COMPUZZ_API_KEY\')],',
        '        CURLOPT_RETURNTRANSFER => true,',
        '    ]);',
        '    $page = json_decode(curl_exec($ch), true);',
        '    foreach ($page[\'data\'] as $r) { echo $r[\'id\'], \' \', $r[\'status\'], PHP_EOL; }',
        '    $cursor = $page[\'hasMore\'] ? $page[\'nextCursor\'] : null;',
        '} while ($cursor);'
      ),
      python: lines(
        'params = {"status": "delivered", "limit": 100}',
        'while True:',
        '    page = requests.get(API + "/graphical-requests", headers=HEADERS, params=params).json()',
        '    for r in page["data"]:',
        '        print(r["id"], r["externalRef"], r["status"])',
        '    if not page["hasMore"]:',
        '        break',
        '    params["startingAfter"] = page["nextCursor"]'
      )
    },

    quote: {
      curl: lines(
        '# Read the quote and the question of the graphic designer',
        'curl {{BASE}}/graphical-requests/$ID/messages -H "Authorization: Bearer $COMPUZZ_API_KEY"',
        '',
        '# Agree with the new tariff scale: the work goes on',
        'curl -X POST {{BASE}}/graphical-requests/$ID/quote/accept -H "Authorization: Bearer $COMPUZZ_API_KEY"',
        '',
        '# ... or answer with a message (and files)',
        'curl {{BASE}}/graphical-requests/$ID/messages \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY" \\',
        '  -F text="Only the round logo, not the slogan" \\',
        '  -F file=@logo-round.png',
        '',
        '# ... or give up: nothing is charged',
        'curl -X POST {{BASE}}/graphical-requests/$ID/cancel -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      ),
      python: lines(
        'request = requests.get(f"{API}/graphical-requests/{request_id}", headers=HEADERS).json()',
        'if request["status"] == "action_required":',
        '    messages = requests.get(f"{API}/graphical-requests/{request_id}/messages", headers=HEADERS).json()',
        '    print("Designer:", messages["data"][-1]["text"])',
        '    print("New price:", request["quote"]["totalCredits"], "credits")',
        '    requests.post(f"{API}/graphical-requests/{request_id}/quote/accept", headers=HEADERS)'
      )
    },

    download: {
      curl: lines(
        'curl -L -o result.ai \\',
        '  "{{BASE}}/graphical-requests/$ID/files/$FILE_ID" \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      ),
      node: lines(
        'import { writeFile } from \'node:fs/promises\';',
        '',
        'for (const file of request.files.filter(f => f.role === \'result\' && f.latest)) {',
        '  const res = await fetch(file.downloadUrl, {',
        '    headers: { Authorization: `Bearer ${process.env.COMPUZZ_API_KEY}` }',
        '  });',
        '  await writeFile(file.name, Buffer.from(await res.arrayBuffer()));',
        '}'
      ),
      php: lines(
        'foreach ($request[\'files\'] as $file) {',
        '    if ($file[\'role\'] !== \'result\' || empty($file[\'latest\'])) continue;',
        '    $ch = curl_init($file[\'downloadUrl\']);',
        '    curl_setopt_array($ch, [',
        '        CURLOPT_HTTPHEADER => [\'Authorization: Bearer \' . getenv(\'COMPUZZ_API_KEY\')],',
        '        CURLOPT_RETURNTRANSFER => true,',
        '        CURLOPT_FOLLOWLOCATION => true,',
        '    ]);',
        '    file_put_contents($file[\'name\'], curl_exec($ch));',
        '}'
      ),
      python: lines(
        'for f in request["files"]:',
        '    if f["role"] == "result" and f.get("latest"):',
        '        with requests.get(f["downloadUrl"], headers=HEADERS, stream=True) as r:',
        '            r.raise_for_status()',
        '            with open(f["name"], "wb") as out:',
        '                for chunk in r.iter_content(65536):',
        '                    out.write(chunk)'
      )
    },

    accept: {
      curl: lines(
        '# The result is fine: close the request (the credits are debited now)',
        'curl -X POST {{BASE}}/graphical-requests/$ID/accept -H "Authorization: Bearer $COMPUZZ_API_KEY"',
        '',
        '# Not quite: ask for a correction instead (the request stays open)',
        'curl {{BASE}}/graphical-requests/$ID/messages \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY" \\',
        '  -H "Content-Type: application/json" \\',
        '  -d \'{"text": "The red must be Pantone 485 C, not 186 C"}\''
      )
    },

    credits: {
      json: lines(
        '{',
        '  "balance": 240,',
        '  "available": 228,',
        '  "prices": {',
        '    "vectorization": 6,',
        '    "conversion": 3,',
        '    "remove_background": 5,',
        '    "colorization": 5,',
        '    "urgent": 6',
        '  }',
        '}'
      )
    },

    webhookSet: {
      curl: lines(
        'curl -X PUT {{BASE}}/webhook \\',
        '  -H "Authorization: Bearer $COMPUZZ_API_KEY" \\',
        '  -H "Content-Type: application/json" \\',
        '  -d \'{"url": "https://www.your-company.com/hooks/compuzz"}\'',
        '',
        '# {"url": "https://www.your-company.com/hooks/compuzz", "secret": "whsec_9c1f...", "events": [...]}',
        '',
        '# Send a test event',
        'curl -X POST {{BASE}}/webhook/ping -H "Authorization: Bearer $COMPUZZ_API_KEY"'
      )
    },

    event: {
      json: lines(
        'POST https://www.your-company.com/hooks/compuzz',
        'Content-Type: application/json; charset=utf-8',
        'User-Agent: Compuzz-Webhooks/1.0',
        'X-Compuzz-Signature: t=1761140451,v1=5f2b6c0e9d8a...',
        '',
        '{',
        '  "id": "evt_3b0d9a7c2f6e4e1a8c5b7d9e0f1a2b3c",',
        '  "object": "event",',
        '  "type": "request.delivered",',
        '  "createdAt": "2026-10-22T13:40:51Z",',
        '  "data": { "id": "48211_6f1c...", "object": "graphical_request", "status": "delivered", "files": [ ... ] }',
        '}'
      )
    },

    verify: {
      node: lines(
        'import crypto from \'node:crypto\';',
        'import express from \'express\';',
        '',
        'const app = express();',
        '',
        '// Keep the raw body: the signature is computed on the exact bytes received.',
        'app.post(\'/hooks/compuzz\', express.raw({ type: \'application/json\' }), (req, res) => {',
        '  const header = req.get(\'X-Compuzz-Signature\') || \'\';',
        '  const parts = Object.fromEntries(header.split(\',\').map(p => p.split(\'=\')));',
        '  const expected = crypto.createHmac(\'sha256\', process.env.COMPUZZ_WEBHOOK_SECRET)',
        '    .update(`${parts.t}.`).update(req.body).digest(\'hex\');',
        '  const fresh = Math.abs(Date.now() / 1000 - Number(parts.t)) < 300;',
        '  if (!fresh || !parts.v1 || !crypto.timingSafeEqual(Buffer.from(expected), Buffer.from(parts.v1))) {',
        '    return res.sendStatus(400);',
        '  }',
        '  const event = JSON.parse(req.body);',
        '  if (event.type === \'request.delivered\') {',
        '    queueDownload(event.data.id);   // answer fast, work later',
        '  }',
        '  res.sendStatus(200);',
        '});'
      ),
      php: lines(
        '$body   = file_get_contents(\'php://input\');',
        '$header = $_SERVER[\'HTTP_X_COMPUZZ_SIGNATURE\'] ?? \'\';',
        'parse_str(str_replace(\',\', \'&\', $header), $parts);',
        '',
        '$expected = hash_hmac(\'sha256\', $parts[\'t\'] . \'.\' . $body, getenv(\'COMPUZZ_WEBHOOK_SECRET\'));',
        'if (abs(time() - (int) $parts[\'t\']) > 300 || !hash_equals($expected, $parts[\'v1\'] ?? \'\')) {',
        '    http_response_code(400);',
        '    exit;',
        '}',
        '',
        '$event = json_decode($body, true);',
        'if ($event[\'type\'] === \'request.delivered\') {',
        '    queue_download($event[\'data\'][\'id\']);',
        '}',
        'http_response_code(200);'
      ),
      python: lines(
        'import hashlib, hmac, os, time',
        'from flask import Flask, request, abort',
        '',
        'app = Flask(__name__)',
        '',
        '@app.post("/hooks/compuzz")',
        'def compuzz_hook():',
        '    body = request.get_data()',
        '    parts = dict(p.split("=", 1) for p in request.headers.get("X-Compuzz-Signature", "").split(",") if "=" in p)',
        '    expected = hmac.new(os.environ["COMPUZZ_WEBHOOK_SECRET"].encode(),',
        '                        parts.get("t", "").encode() + b"." + body, hashlib.sha256).hexdigest()',
        '    if abs(time.time() - int(parts.get("t", 0))) > 300 or not hmac.compare_digest(expected, parts.get("v1", "")):',
        '        abort(400)',
        '    event = request.get_json()',
        '    if event["type"] == "request.delivered":',
        '        queue_download(event["data"]["id"])',
        '    return "", 200'
      )
    },

    error: {
      json: lines(
        'HTTP/1.1 402 Payment Required',
        '',
        '{',
        '  "error": {',
        '    "status": 402,',
        '    "code": "insufficient_credits",',
        '    "message": "Not enough credits on the account: top it up in the dashboard (Account > Credits)"',
        '  }',
        '}'
      )
    }
  };
});

